export class CreateActionRequest {
  Name: string;
  Description: string;
}
